import errors from './errors/index.js';
import translation from './translation/index.js';
const pt_br = {
    translation,
    errors,
};
export default Object.freeze(pt_br);
